import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-inline-notification',
    templateUrl: './inline-notification.component.html',
    styleUrls: ['./inline-notification.component.scss'],
    standalone: false
})
export class InlineNotificationComponent {

    @Input() public icon: string;

}
